const GRAPHQL_PATH = "/graphql";
const BASE_URL_KEY = "baseURL";
const JS_PATH = "/static/app/main.chunk.js";
const PRODUCTION_ORIGIN = "https://app.duocards.com";
const PR_PREVIEW_PATTERN = /^https:\/\/duocards-stg-pr-\d+\.herokuapp\.com\/static\/app\/main\.chunk\.js$/;

const getStoredBaseURL = () => localStorage.getItem(BASE_URL_KEY);

const buildJsUrl = (origin: string) => `${origin}${JS_PATH}`;

export const getJsBaseURL = (): string => {
  const stored = getStoredBaseURL();
  if (stored) return stored;

  const defaultOrigin = isRunningFromPrPreview() ? window.location.origin : PRODUCTION_ORIGIN;
  return buildJsUrl(defaultOrigin);
};

export const isRunningFromPrPreview = (): boolean => {
  const testUrl = getStoredBaseURL() || buildJsUrl(window.location.origin);
  return PR_PREVIEW_PATTERN.test(testUrl);
};

export function getReactAppApi(): string {
  const api = process.env.REACT_APP_API;
  if (api) return api;
  if (isRunningFromPrPreview()) return new URL(getJsBaseURL()).origin + GRAPHQL_PATH;
  return "http://localhost:4000" + GRAPHQL_PATH;
}

export function getApiOrigin(): string {
  return new URL(getReactAppApi()).origin;
}
